// extracted by mini-css-extract-plugin
export default {"players":"PlayersAll_players__0LpYm","players_title":"PlayersAll_players_title__WZzYj","player":"PlayersAll_player__RDbfK","pagination":"PlayersAll_pagination__VOtTh"};